{
  "404": {
    "title": "Bu sayfa balık tutmaya gitti.",
    "text": "Bunun doğru olmadığını düşünüyorsanız lütfen bize şu adresten bir mesaj gönderin: ",
    "back_button": "Kontrol paneline geri dön"
  },
  "auth": {
    "agree": "katılıyorum",
    "createAccount": "Hesap oluşturmak",
    "createNewAccount": "Yeni Hesap Oluştur",
    "email": "E-posta",
    "login": "Giriş",
    "password": "Şifre",
    "recover_password": "Şifreyi kurtar",
    "sign_up": "Üye ol",
    "keep_logged_in": "Oturumumu açık tut",
    "termsOfUse": "Kullanım Koşulları.",
    "reset_password": "Şifreyi sıfırla"
  },
  "typography": {
    "primary": "Birincil metin stilleri",
    "secondary": "İkincil metin stilleri"
  },
  "dashboard": {
    "versions": "Sürümler",
    "setupRemoteConnections": "Uzak Bağlantıları Kur",
    "currentVisitors": "Mevcut Ziyaretçiler",
    "navigationLayout": "gezinme düzeni",
    "topBarButton": "Üst Çubuk",
    "sideBarButton": "Kenar Çubuğu"
  },
  "language": {
    "brazilian_portuguese": "Portekizce",
    "english": "İngilizce",
    "spanish": "İspanyol",
    "simplified_chinese": "Basitleştirilmiş Çince",
    "persian": "Farsça"
  },
  "menu": {
    "404": "404",
    "auth": "Yetki",
    "buttons": "Düğmeler",
    "timelines": "Zaman çizelgeleri",
    "dashboard": "Kontrol Paneli",
    "billing": "Faturalandırma",
    "login": "Giriş",
    "preferences": "Hesap ayarları",
    "payments": "Ödemeler",
    "settings": "Uygulama ayarları",
    "pricing-plans": "Fiyatlandırma planları",
    "payment-methods": "Ödeme yöntemleri",
    "signup": "Üye ol",
    "recover-password": "Şifreyi kurtar",
    "recover-password-email": "Şifre e-postasını kurtar",
    "faq": "SSS",
    "users": "Kullanıcılar",
    "projects": "Projeler",
    "t-service": "Teknik Servis",
    "new-t-service": "Yeni Teknik Servis",
    "devices": "Cihazlar",
    "sparepart": "Yedek Parça"
  },
  "messages": {
    "all": "Tüm mesajları gör",
    "new": "{name}'dan yeni mesajlar",
    "mark_as_read": "Okundu Olarak İşaretle"
  },
  "navbar": {
    "messageUs": "Web geliştirme soruları:",
    "repository": "GitHub Deposu"
  },
  "notifications": {
    "all": "Tüm bildirimleri görün",
    "less": "Daha az bildirim görün",
    "mark_as_read": "Okundu olarak işaretle",
    "sentMessage": "sana bir mesaj gönderdim",
    "uploadedZip": "{type} ile yeni bir Zip dosyası yükledi",
    "startedTopic": "yeni bir konu başlattım"
  },
  "user": {
    "language": "Dili değiştir",
    "logout": "Oturumu kapat",
    "profile": "Profil",
    "settings": "Ayarlar",
    "billing": "Faturalandırma",
    "faq": "SSS",
    "helpAndSupport": "Yardım ve destek",
    "projects": "Projeler",
    "forms": "Formlar",
    "t-service": "Teknik Servis",
    "account": "Hesap",
    "explore": "Keşfetmek"
  },
  "system": {
    "general_preferences": "Genel Ayarlar",
    "language": "Dil"
  },
  "treeView": {
    "basic": "Temel",
    "icons": "Simgeler",
    "selectable": "Seçilebilir",
    "editable": "Düzenlenebilir",
    "advanced": "Gelişmiş"
  },
  "chat": {
    "title": "Sohbet",
    "sendButton": "Göndermek"
  },
  "spacingPlayground": {
    "value": "Değer",
    "margin": "Marj",
    "padding": "Dolgu"
  },
  "spacing": {
    "title": "Aralık"
  },
  "cards": {
    "cards": "Kartlar",
    "fixed": "Sabit",
    "floating": "Yüzer",
    "contentText": "Zebraların kendine özgü çizgileri, onları insanların en aşina olduğu hayvanlardan biri haline getiriyor.",
    "contentTextLong": "Zebraların kendine özgü çizgileri, onları insanların en aşina olduğu hayvanlardan biri haline getiriyor. ",
    "rowHeight": "Satır yüksekliği",
    "title": {
      "default": "Varsayılan",
      "withControls": "Kontrollerle",
      "customHeader": "Özel başlık",
      "withoutHeader": "Başlıksız",
      "withImage": "Resimli",
      "withTitleOnImage": "Resimde başlık var",
      "withCustomTitleOnImage": "Resimde özel başlık ile",
      "withStripe": "Şeritli",
      "withBackground": "Arka planlı"
    },
    "button": {
      "main": "Ana",
      "cancel": "İptal",
      "showMore": "Daha Fazla Göster",
      "readMore": "Daha Fazla Göster"
    },
    "link": {
      "edit": "Düzenlemek",
      "setAsDefault": "Varsayılan olarak ayarla",
      "delete": "Silmek",
      "traveling": "Seyahat",
      "france": "Fransa",
      "review": "Gözden geçirmek",
      "feedback": "Geri bildirim bırakın",
      "readFull": "Makalenin tamamını okuyun",
      "secondaryAction": "İkincil eylem",
      "action1": "Eylem 1",
      "action2": "Eylem 2"
    }
  },
  "colors": {
    "themeColors": "Tema Renkleri",
    "extraColors": "Ekstra Renkler",
    "gradients": {
      "basic": {
        "title": "Düğme Degradeleri"
      },
      "hovered": {
        "title": "Vurgulu Düğme Degradeleri",
        "text": "Fareyle üzerine gelme durumu için orijinal stile (degrade veya düz renk) uygulanan %15 açıklaştırma."
      },
      "pressed": {
        "title": "Basılan Düğme Degradeleri",
        "text": "Basılmış durum için orijinal stile (degrade veya düz renk) uygulanan %15 koyulaştırma."
      }
    }
  },
  "tabs": {
    "alignment": "Sekmelerin hizalanması",
    "overflow": "Sekme taşması",
    "hidden": "Gizli kaydırıcılı sekmeler",
    "grow": "Sekmeler büyüyor"
  },
  "helpAndSupport": "Yardım ve destek",
  "aboutCMMSAdmin": "CMMS Yöneticisi Hakkında",
  "supportAndConsulting": "Destek",
  "search": {
    "placeholder": "Ara..."
  },
  "buttonSelect": {
    "dark": "Karanlık",
    "light": "Aydınlık"
  },
  "vuestic": {
    "search": "Ara",
    "noOptions": "Öğe bulunamadı",
    "ok": "TAMAM",
    "cancel": "İptal",
    "uploadFile": "Dosya yükle",
    "undo": "Geri al",
    "dropzone": "Yüklemek için dosyaları buraya bırakın",
    "fileDeleted": "Dosya silindi",
    "closeAlert": "yakın uyarı",
    "backToTop": "başa dön",
    "toggleDropdown": "açılır menüyü değiştir",
    "carousel": "atlıkarınca",
    "goPreviousSlide": "önceki slayta git",
    "goNextSlide": "sonraki slayta git",
    "goSlide": "git slayt {dizin}",
    "slideOf": "{length}'in {index} slaytı",
    "close": "kapalı",
    "openColorPicker": "renk seçiciyi aç",
    "colorSelection": "renk seçimi",
    "colorName": "renk {renk}",
    "decreaseCounter": "sayacı azalt",
    "increaseCounter": "sayacı artır",
    "selectAllRows": "tüm satırları seç",
    "sortColumnBy": "Sütunu {name}'e göre sırala",
    "selectRowByIndex": "{indeks} satırını seç",
    "resetDate": "tarihi sıfırla",
    "nextPeriod": "gelecek dönem",
    "switchView": "görünümü değiştir",
    "previousPeriod": "önceki dönem",
    "removeFile": "dosyayı kaldır",
    "reset": "sıfırlama",
    "pagination": "sayfalandırma",
    "goToTheFirstPage": "ilk sayfaya git",
    "goToPreviousPage": "önceki sayfaya git",
    "goToSpecificPage": "{page} sayfasına git",
    "goToSpecificPageInput": "gidilecek sayfa numarasını girin",
    "goNextPage": "sonraki sayfaya git",
    "goLastPage": "son sayfaya git",
    "currentRating": "mevcut derecelendirme {value} / {max}",
    "voteRating": "oy puanı {value} / {max}",
    "optionsFilter": "seçenekler filtresi",
    "splitPanels": "bölünmüş paneller",
    "movePaginationLeft": "sayfalamayı sola taşı",
    "movePaginationRight": "sayfalamayı sağa taşı",
    "resetTime": "zamanı sıfırla",
    "closeToast": "tostu kapat",
    "selectedOption": "Seçilen seçenek",
    "noSelectedOption": "Seçenek seçilmedi",
    "breadcrumbs": "ekmek kırıntıları",
    "counterValue": "sayaç değeri",
    "selectedDate": "seçilen tarih",
    "selectedTime": "seçilen zaman",
    "progressState": "ilerleme durumu",
    "color": "renk",
    "next": "Sonraki",
    "back": "Öncesi",
    "finish": "Tamamla",
    "step": "adım",
    "progress": "ilerlemek",
    "loading": "Yükleniyor",
    "sliderValue": "Mevcut kaydırma çubuğu değeri: {value}",
    "switch": "Anahtar",
    "inputField": "Giriş alanı",
    "fileTypeIncorrect": "Dosya türü yanlış",
    "select": "Bir seçenek seçin"
  },
  "device": "Cihaz",
  "add": "Ekle",
  "map": "Harita",
  "card": "Kart",
  "table": "Tablo",
  "employee": "Personel",
  "youve-successfully-changed-your-name": "You've successfully changed your name",
  "modal": {
    "update_success_message": "Degisiklikler basariyla kaydedildi "
  },
  "no-devices": "Cihaz Yok",
  "two-factor-auth": "Iki Asamali Dogrulama",
  "users": "Kullanicilar"
}
